import { StyledIcon } from './Styled'

export interface ColoredIconProps {
  src?: string
  color?: string | null
  contentSize?: string | null
  contentWidth?: string | null
  contentHeight?: string | null
  [key: string]: any
}

export const ColoredIcon = ({
  src,
  color = null,
  contentSize = null,
  contentWidth = null,
  contentHeight = null,
  ...props
}: ColoredIconProps) => {
  return (
    <StyledIcon
      {...props}
      src={src}
      color={color ?? undefined}
      contentWidth={contentWidth}
      contentHeight={contentHeight}
    />
  )
}
